import { Button as ChakraButton } from "@chakra-ui/react"
import { Tokens } from "../mirrorful/theme"


export default function Button({name,label,style,children,handleClick,id,w}){
    return (
        <ChakraButton
        id={id}
        className={name}
        onClick={handleClick}
        borderRadius={'30px'}
        bgGradient={`linear(to-r, ${Tokens.blue.base}, ${Tokens.purple.base})`}
        _hover={{
          boxShadow: `0 0 20px 3px ${Tokens.blue.shades['400']}`,
        }}
        color={'white'}
        height={'34px'}
        paddingX={'28px'}
        fontSize={'12px'}
        fontWeight={'medium'}
     width={"100%"}
     style={style}
     
      >
        {label}
        {children}
      </ChakraButton>
    )
}